var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.19595 10.9945C1.09798 11.1019 1.03332 11.2354 1.00984 11.3789C0.98637 11.5223 1.00509 11.6695 1.06373 11.8025C1.12237 11.9356 1.2184 12.0487 1.34014 12.1281C1.46188 12.2075 1.60409 12.2499 1.74945 12.25H13.7495C13.8948 12.2501 14.037 12.2079 14.1589 12.1286C14.2807 12.0493 14.3768 11.9363 14.4356 11.8034C14.4944 11.6705 14.5133 11.5233 14.49 11.3798C14.4667 11.2364 14.4023 11.1028 14.3045 10.9952C13.307 9.967 12.2495 8.87425 12.2495 5.5C12.2495 4.30653 11.7753 3.16193 10.9314 2.31802C10.0875 1.47411 8.94293 1 7.74945 1C6.55598 1 5.41139 1.47411 4.56747 2.31802C3.72356 3.16193 3.24945 4.30653 3.24945 5.5C3.24945 8.87425 2.1912 9.967 1.19595 10.9945Z",
    stroke: "#102039",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.acc799e0edb3ddbc957272b917e99d92.svg";
export { ForwardRef as ReactComponent };